module.exports = __webpack_public_path__ + "img/logo.9c4798cb.svg";